import React from 'react';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { DownloadButtonProps } from './DownloadButton.props';
import './DownloadButton.css';

export const DownloadButton = ({
  onDownload,
  label = 'Download Report',
  disabled,
  loading,
  className
}: DownloadButtonProps) => {
  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon sx={{ fontSize: 24 }} />}
      onClick={onDownload}
      disabled={disabled || loading}
      className={['download-button', className].filter(Boolean).join(' ')}
    >
      {label}
    </Button>
  );
};